class MvPhotos {
  constructor(rootSelector) {
    this.root = document.querySelector(rootSelector);

    if (!this.root) {
      return;
    }

    this.photos = this.root.querySelectorAll('.js-p-top-mv-photo');

    if (this.photos.length === 0) {
      return;
    }

    this.run();
  }

  run() {
    gsap.set(this.photos, {
      opacity: 0,
      scale: 1.2,
    });

    const timeline = gsap.timeline({
      defaults: {
        duration: 0.9,
        ease: 'power3.out',
      },
      onComplete: () => {
        this.root.classList.add('is-animated');
        gsap.set(this.photos, { clearProps: 'transform,will-change' });
      },
    });

    timeline.to(this.photos, {
      opacity: 1,
      scale: 1,
      stagger: 0.25,
    });
  }
}
